import styled from 'styled-components';

export const ToastWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  background: #000;
  color: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.16);
`;

export const ToastBody = styled.div`
  flex-grow: 1;

  h6 {
    font-family: "Crimson Text";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.25px;
    margin: 0;
    margin-bottom: 0.5rem;
  }

  p {
    font-family: "Crimson Text";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin: 0;
    color: #fff; 
  }
`;